import React, { useState, useEffect } from 'react';

const Navbar: React.FC = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTo = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav
      id="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 border-b ${
        scrolled ? 'bg-black/96 backdrop-blur-xl border-mid' : 'border-transparent'
      }`}
    >
      <div className="max-w-[1260px] mx-auto px-10 py-5 flex items-center justify-between">
        <div className="flex flex-col leading-none gap-1">
          <span className="font-serif text-3xl font-bold tracking-[7px] text-white">
            GERAK
          </span>
          <span className="text-[9px] tracking-[3.5px] text-silver uppercase">
            Fashion & Classic
          </span>
        </div>

        <div className="hidden md:flex gap-11 items-center">
          {['hero', 'collections', 'univers', 'contact'].map((item, index) => (
            <button
              key={item}
              className="nav-link text-[10px] tracking-[2.5px] uppercase text-silverLight py-1 relative after:content-[''] after:absolute after:bottom-[-2px] after:left-0 after:w-0 after:h-px after:bg-gold after:transition-all after:duration-300 hover:text-white hover:after:w-full"
              onClick={() => scrollTo(item)}
            >
              {item === 'hero' ? 'La Marque' : 
               item === 'collections' ? 'Collections' :
               item === 'univers' ? 'Univers' : 'Contact'}
            </button>
          ))}
        </div>

        <button
          className="md:hidden flex flex-col gap-1 p-1"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span
            className="w-6 h-[1.5px] bg-white transition-all duration-300"
            style={{ transform: menuOpen ? 'rotate(45deg) translateY(7px)' : 'none' }}
          ></span>
          <span
            className="w-6 h-[1.5px] bg-white transition-all duration-300"
            style={{ opacity: menuOpen ? 0 : 1 }}
          ></span>
          <span
            className="w-6 h-[1.5px] bg-white transition-all duration-300"
            style={{ transform: menuOpen ? 'rotate(-45deg) translateY(-7px)' : 'none' }}
          ></span>
        </button>
      </div>

      <div
        className={`md:hidden flex-col bg-black/98 border-t border-mid px-10 pb-7 ${
          menuOpen ? 'flex' : 'hidden'
        }`}
      >
        {['hero', 'collections', 'univers', 'contact'].map((item, index) => (
          <button
            key={item}
            className="text-left py-4 text-sm tracking-[3px] uppercase text-silverLight border-b border-mid last:border-b-0 hover:text-white"
            onClick={() => scrollTo(item)}
          >
            {item === 'hero' ? 'La Marque' : 
             item === 'collections' ? 'Collections' :
             item === 'univers' ? 'Univers' : 'Contact'}
          </button>
        ))}
      </div>
    </nav>
  );
};

export default Navbar;